// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Button__root--NBpr {
    --icon-size: 24px; 
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    cursor: pointer;
    transition: color 0.25s ease-in-out, border-color 0.25s ease-in-out, background-color 0.25s ease-in-out, box-shadow 0.25s ease-in-out;
    white-space: nowrap;
    color: var(--main-color);
    outline: none;
    border: none;
    background-color: transparent;
    border-radius: 6px;
    padding: 12px 16px;
    font-size: 14px;
    font-weight: 600;
    line-height: 28px;
    position: relative;
    text-transform: uppercase;
}

    .Button__root--NBpr.Button__loading--bzYz {
        pointer-events: none;
    }

    .Button__root--NBpr.Button__rounded--s26k {
        border-radius: 50%;
    }

.Button__primary--WQLA {
    background-color: var(--main-color);
    color: var(--tertiary-color);
}

@media (hover: hover) and (pointer: fine) {
        .Button__primary--WQLA:hover {
            box-shadow: 0px 1.72px 6.27px 0px #1161FF;
        }

        .Button__primary--WQLA:active {
            box-shadow: none;
            background-color: rgba(56, 87, 255, 0.8);
        }
    }

.Button__primary--WQLA.Button__disabled--UNLS {
        opacity: 0.5;
        pointer-events: none;
    }

.Button__secondary--Ck4G {
    color: var(--secondary-color);
    border: 1px solid var(--obscure-color);
}

.Button__secondary--Ck4G.Button__disabled--UNLS {
        pointer-events: none;
        color: var(--tertiary-color);
        border-color: transparent !important;
        background-color: var(--obscure-color);
    }

.Button__tertiary--RFiQ {
    color: var(--main-color);
    border: 1px solid var(--main-color);
}

@media (hover: hover) and (pointer: fine) {
        .Button__tertiary--RFiQ:hover, .Button__tertiary--RFiQ:active {
            background-color: var(--main-color);
            color: var(--tertiary-color);
        }

    }

.Button__tertiary--RFiQ.Button__disabled--UNLS {
        pointer-events: none;
        background-color: var(--obscure-color);
        color: var(--tertiary-color);
        border-color: transparent !important;
    }

.Button__icon--u54C {
    width: var(--icon-size);
    height: var(--icon-size);
}

.Button__withoutLabel--zQXD {
    padding: 8px;
}

.Button__loader--APGB {
    position: absolute;
    bottom: 14px;
    right: 12px;
    margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/Button/Button.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,eAAe;IACf,qIAAqI;IACrI,mBAAmB;IACnB,wBAAwB;IACxB,aAAa;IACb,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;AAS7B;;IAPI;QACI,oBAAoB;IACxB;;IAEA;QACI,kBAAkB;IACtB;;AAGJ;IACI,mCAAmC;IACnC,4BAA4B;AAiBhC;;AAfI;QACI;YACI,yCAAyC;QAC7C;;QAEA;YACI,gBAAgB;YAChB,wCAAwC;QAC5C;IACJ;;AAEA;QACI,YAAY;QACZ,oBAAoB;IACxB;;AAGJ;IACI,6BAA6B;IAC7B,sCAAsC;AAQ1C;;AANI;QACI,oBAAoB;QACpB,4BAA4B;QAC5B,oCAAoC;QACpC,sCAAsC;IAC1C;;AAGJ;IACI,wBAAwB;IACxB,mCAAmC;AAgBvC;;AAdI;QACI;YACI,mCAAmC;YACnC,4BAA4B;QAChC;;IAEJ;;AAEA;QACI,oBAAoB;QACpB,sCAAsC;QACtC,4BAA4B;QAC5B,oCAAoC;IACxC;;AAGJ;IACI,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,SAAS;AACb","sourcesContent":[".root {\n    --icon-size: 24px; \n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    cursor: pointer;\n    transition: color 0.25s ease-in-out, border-color 0.25s ease-in-out, background-color 0.25s ease-in-out, box-shadow 0.25s ease-in-out;\n    white-space: nowrap;\n    color: var(--main-color);\n    outline: none;\n    border: none;\n    background-color: transparent;\n    border-radius: 6px;\n    padding: 12px 16px;\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 28px;\n    position: relative;\n    text-transform: uppercase;\n\n    &.loading {\n        pointer-events: none;\n    }\n\n    &.rounded {\n        border-radius: 50%;\n    }\n}\n\n.primary {\n    background-color: var(--main-color);\n    color: var(--tertiary-color);\n\n    @media (hover: hover) and (pointer: fine) {\n        &:hover {\n            box-shadow: 0px 1.72px 6.27px 0px #1161FF;\n        }\n\n        &:active {\n            box-shadow: none;\n            background-color: rgba(56, 87, 255, 0.8);\n        }\n    }\n\n    &.disabled {\n        opacity: 0.5;\n        pointer-events: none;\n    }\n}\n\n.secondary {\n    color: var(--secondary-color);\n    border: 1px solid var(--obscure-color);\n\n    &.disabled {\n        pointer-events: none;\n        color: var(--tertiary-color);\n        border-color: transparent !important;\n        background-color: var(--obscure-color);\n    }\n}\n\n.tertiary {\n    color: var(--main-color);\n    border: 1px solid var(--main-color);\n\n    @media (hover: hover) and (pointer: fine) {\n        &:hover, &:active {\n            background-color: var(--main-color);\n            color: var(--tertiary-color);\n        }\n\n    }\n\n    &.disabled {\n        pointer-events: none;\n        background-color: var(--obscure-color);\n        color: var(--tertiary-color);\n        border-color: transparent !important;\n    }\n}\n\n.icon {\n    width: var(--icon-size);\n    height: var(--icon-size);\n}\n\n.withoutLabel {\n    padding: 8px;\n}\n\n.loader {\n    position: absolute;\n    bottom: 14px;\n    right: 12px;\n    margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Button__root--NBpr`,
	"loading": `Button__loading--bzYz`,
	"rounded": `Button__rounded--s26k`,
	"primary": `Button__primary--WQLA`,
	"disabled": `Button__disabled--UNLS`,
	"secondary": `Button__secondary--Ck4G`,
	"tertiary": `Button__tertiary--RFiQ`,
	"icon": `Button__icon--u54C`,
	"withoutLabel": `Button__withoutLabel--zQXD`,
	"loader": `Button__loader--APGB`
};
export default ___CSS_LOADER_EXPORT___;
